import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToTakeControl');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeAssertive')}
                                                        className="link_color task button-link-redirect">How to be assertive</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCreateTeamIdentity')}
                                                        className="link_color task button-link-redirect">How to create team
                                                        identity</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeResponsibility')}
                                                        className="link_color task button-link-redirect">How to take
                                                        responsibility</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDelegate')}
                                                        className="link_color task button-link-redirect">How to delegate</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBuildResilience')}
                                                        className="link_color task button-link-redirect">How to build resilience</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}
                                                        className="link_color task button-link-redirect">How to get the most out of
                                                        yourself.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Vroom, V. &amp; Jago, A.
                                                    (1988).
                                                    <span
                                                        className="subtiltereg">The new leadership. </span> Upper
                                                    Saddle River, NJ: Prentice-Hall.</p></li>
                                                <li><p className="further_info_content">Boerner, S., &amp; von
                                                    Streit, C. (2007). Promoting orchestral performance: the
                                                    interplay between musicians’
                                                    mood and a conductor’s leadership style.
                                                    <span
                                                        className="subtiltereg">  Psychology of Music, </span> 35(1),
                                                    132.</p></li>
                                                <li><p className="further_info_content"> Karasek, R. (1979). Job
                                                    demands, job decision latitude and mental strain:
                                                    implications for job redesign. <span
                                                        className="subtiltereg"> Administrative Science Quarterly,  </span> 24,
                                                    285-308.</p></li>
                                                <li><p className="further_info_content"> Häusser, J. A.,
                                                    Mojzisch, A., Niesel, M., &amp; Schulz-Hardt, S. (2010). Ten
                                                    years on: A review of recent research
                                                    on the Job Demand–Control (-Support) model and psychological
                                                    well-being.
                                                    <span
                                                        className="subtiltereg"> Work &amp; Stress, </span> 24(1),
                                                    1-35.</p></li>
                                                <li><p className="further_info_content">Locke, E. A., Shaw, K.
                                                    N., Saari, L. M., &amp; Latham, G. P. (1981). Goal setting
                                                    and task performance:
                                                    1969–1980.
                                                    <span
                                                        className="subtiltereg"> Psychological Bulletin,  </span> 90(1),
                                                    125.</p></li>
                                                <li><p className="further_info_content">Van Eerde,
                                                    W., &amp; Thierry, H. (1996). Vroom’s expectancy models and
                                                    work-related criteria: A meta-analysis.
                                                    <span
                                                        className="subtiltereg">Journal of Applied Psychology, </span> 81(5),
                                                    575.</p></li>
                                            </ol>
                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}